export const apiConstants = {
  url: "/api/wallconnection"
};
